import {
  ADD_ITEM_TO_UPLOADED_REGISTRY,
  REMOVE_ITEM_FROM_UPLOADED_REGISTRY,
} from '../actions/uploaded-registry-actions';

export function uploadedRegistry(state = [], action) {
  switch (action.type) {
    case ADD_ITEM_TO_UPLOADED_REGISTRY:
      return state.concat(action.payload);
    case REMOVE_ITEM_FROM_UPLOADED_REGISTRY:
      return state.filter(item => {
        if (
          item[action.payload.by] !== undefined &&
          item[action.payload.by] !== action.payload.value
        ) {
          return true;
        } else {
          return false;
        }
      });
    default:
      return state;
  }
}
